import { render, staticRenderFns } from "./teaser.vue?vue&type=template&id=cb9e129e&scoped=true&"
import script from "./teaser.vue?vue&type=script&lang=js&"
export * from "./teaser.vue?vue&type=script&lang=js&"
import style0 from "./teaser.vue?vue&type=style&index=0&id=cb9e129e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb9e129e",
  null
  
)

export default component.exports